import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";

// Component imports
import InputLayout from "../../../atoms/InputLayout";
import Error from "../../../atoms/Error";

// Remark form for rejection
 const RemarkForm = ({ onClose, onSubmit }) => {
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [cookies] = useCookies(["e_t"]);

    const initialValues = {
        remark: "",
    };

    const validationSchema = Yup.object().shape({
        remark: Yup.string().required("Remark is required")
    });

    const handleSubmit = (values, { resetForm }) => {
        onSubmit(values.remark);
    };

    // Form observer to track form state changes
    const FormObserver = ({ onFormDirty }) => {
        return null;
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur={true}
            validateOnChange={true}
        >
            {({ values, setFieldValue, touched, errors, handleBlur, dirty }) => (
                <>
                    <FormObserver onFormDirty={setIsFormDirty} />
                    <Form>
                        <div className="row gx-4">
                            <InputLayout>
                                <label className="required-field">Rejection Remark</label>
                                <textarea
                                    className={`form-control ${touched.remark && errors.remark ? "is-invalid" : ""}`}
                                    name="remark"
                                    id="remark"
                                    placeholder="Please provide reason for rejection"
                                    value={values.remark}
                                    onChange={(e) => setFieldValue("remark", e.target.value)}
                                    onBlur={handleBlur}
                                    rows={4}
                                />
                                <ErrorMessage name="remark" component={Error} />
                            </InputLayout>
                        </div>

                        <div className="modal-footer mt-4 px-4">
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={() => onClose()}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={!dirty}
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
};


export default RemarkForm;